import { observer } from "mobx-react";
import TranslationScope from "../../../../../../translation/translation-scope";
import useTranslation from "../../../../../../translation/hooks/translation-hook";
import { useEffect } from "react";
import usePage from "../../../../../../components/layouts/base-page-layout/page-hook";
import TrackingStatusesEditor from "./tracking-statuses-editor";

const TrackingStatusesEditorPage: React.FC = observer(() => {
    const { setSubTitles } = usePage();

    useEffect(() => {
        setSubTitles(['Portal', 'Content', 'Tracking Statuses']);
    }, [setSubTitles]);

    const { selectedLocale } = useTranslation();

    return (
        <TranslationScope scope="tracking-portal" locale={selectedLocale}>
            <TrackingStatusesEditor />
        </TranslationScope>
    );
});

export default TrackingStatusesEditorPage;